import { isMobile } from 'mobile-device-detect'
import native from 'src/config/native.js'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

const sounds = [
  {
    key: 'message_received',
    sound: 'sfx-notification.m4a'
  },
  {
    key: 'message_sent',
    sound: 'sfx-sent.m4a'
  }
]
let localInterval = null

export default {
  togglePageTitle () {
    if (localInterval) return
    const self = this
    localInterval = setInterval(function () {
      // If browser Tab is/become active, clear interval and reset document title

      if (!self.pageIsHidden()) {
        self.clearPageTitleInterval()
        return
      }

      // Logic when browser tab is inactive
      document.title = document.title.substring(0, 1) === '*'
        ? document.title.substring(2, document.title.length)
        : `* ${document.title}`
    }, 1000)
  },
  resetPageTitle () {
    document.title = document.title.substring(0, 1) === '*' ? document.title.substring(2, document.title.length) : document.title
  },
  clearPageTitleInterval () {
    if (!localInterval) return
    clearInterval(localInterval)
    localInterval = null
    // Reset page title if it has '*' in front
    this.resetPageTitle()
  },
  playSound (soundKey) {
    // prevent message sounds for mobile devices
    if (isMobile) return
    const soundItem = sounds.find(s => s.key === soundKey)
    const sound = new Audio(`${import.meta.env.BASE_URL}sound/${soundItem.sound}`)

    sound.autoplay = true
    sound.volume = 0.8

    sound.onended = () => {
      sound.remove()
    }

    // some browsers need to have a interaction before playing sound (problem eg. reloading)
    document.getElementsByTagName('body')[0]?.click()

    const promise = sound.play()

    if (promise === undefined) return
    promise.catch(() => {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      const alreadyAsked = JSON.parse(localStorage.getItem('playSoundForSafari'))

      if (!isSafari || alreadyAsked) return
      localStorage.setItem('playSoundForSafari', 'true')
      alert('Bitte erlauben Sie Autoplay für diese Webseite um Benachrichtigungstöne zu hören: Einstellungen -> Webseite -> Autoplay')
    })
  },
  pageIsHidden () {
    return document.hidden || document.msHidden || document.webkitHidden || document.mozHidden || !document.hasFocus()
  },
  notifyUser (notification, isMutedMessage) {
    const isMutedChannel = notification.is_muted

    // message is able to trigger inapp notification but channel is muted
    if (isMutedChannel) return

    this.playSound('message_received')
    this.showNotification(notification, isMutedMessage)
    native.vibrate()

    // Toggle document title when there's new message (if browser tab is inactive)
    if (!this.pageIsHidden() || isMobile) return

    this.togglePageTitle()
  },
  showNotification (notification, isMutedMessage) {
    return this.canShowOSNotifications() ? this.OSNotification(notification, isMutedMessage) : this.vueNotification(notification, isMutedMessage)
  },
  canShowOSNotifications () {
    // can't show OS notification if
    // - it's not supported in browser OR
    // - if it's mobile device OR
    // - if browser tab is active

    if (!('Notification' in window) || isMobile || !this.pageIsHidden()) return false
    if (Notification.permission === 'granted') return true
    if (Notification.permission === 'denied') return false

    Notification.requestPermission()
    return false
  },
  OSNotification (notification, blockActions) {
    const data = {
      body: notification.body,
      silent: true
    }
    if (notification.thumbnail_uri) data.icon = notification.thumbnail_uri

    const browserNotification = new Notification(notification.title, data)
    browserNotification.onclick = function () {
      window.focus()
      // do not navigate if user is already on the right page
      if (blockActions) return
      GlobalPrototypes.router.push(notification.uri)
    }
  },
  vueNotification (notification, blockActions) {
    // do not show notification if user is already on the right page
    if (blockActions) return
    GlobalPrototypes.toastNotify({
      type: 'info',
      text: notification.body,
      title: notification.title,
      data: {
        uri: notification.uri
      },
      group: 'update'
    })
  }
}
